import { AHText, Box } from "arkh";
import { FormattedMessage } from "react-intl";
import { Lottie } from "../../components/Lottie";
import { ErrorBoundary } from "react-error-boundary";

export const AddScreenWebNotice = () => {
  return (
    <Box
      space="large"
      style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
    >
      <AHText textAlign="center" type="title-big">
        <FormattedMessage
          defaultMessage="Install a screen"
          description="StorecastAdminDeviceList empty list title"
        />
      </AHText>
      <AHText
        type="title-small-regular"
        color="darkText"
        spaceVertical="large"
        textAlign="center"
      >
        <FormattedMessage
          defaultMessage="In order to use Storecast, go to Storecast.app in the TV's web browser. Continue with the app on your mobile or tablet."
          description="StorecastAdminDeviceList empty list sub title"
          values={{
            newLine: "\n",
          }}
        />
      </AHText>
      <ErrorBoundary fallback={null}>
        <Lottie
          autoPlay
          loop
          source={require("./AddScreen/scan-qr.json")}
          style={{ height: 220 }}
        />
      </ErrorBoundary>
    </Box>
  );
};
